/**
 * Transição cinematográfica do accordion do FAQ: substitui o abre/fecha
 * instantâneo nativo do <details> por uma animação suave (altura + fade +
 * leve slide do conteúdo, seta girando) via GSAP — já carregado
 * globalmente pelo tema (ver dbr-animation-core.js). Sem GSAP disponível
 * (script ainda não carregou) ou com "prefers-reduced-motion", cai pro
 * toggle nativo instantâneo, sem quebrar a funcionalidade.
 */
class DbrFaq extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.dbr-faq__item details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var answer = details.querySelector('.dbr-faq__answer');
      var icon = summary ? summary.querySelector('.icon-caret') : null;
      if (!summary || !answer) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;

        if (details.open) {
          closeItem(details, answer, icon);
        } else {
          openItem(details, answer, icon);
        }
      });
    });
  }
}

function canAnimate() {
  return !!window.gsap && !(window.DbrAnim && window.DbrAnim.reducedMotion);
}

function openItem(details, answer, icon) {
  details.open = true;

  if (!canAnimate()) return;

  details.dataset.animating = 'true';
  window.gsap.set(answer, { height: 0, opacity: 0, y: -8, overflow: 'hidden' });
  window.gsap.to(answer, {
    height: 'auto',
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power3.out',
    onComplete: function () {
      answer.style.overflow = '';
      answer.style.height = '';
      answer.style.transform = '';
      details.dataset.animating = 'false';
    },
  });

  if (icon) {
    window.gsap.fromTo(icon, { rotate: 0 }, { rotate: 180, duration: 0.6, ease: 'power3.out' });
  }
}

function closeItem(details, answer, icon) {
  if (!canAnimate()) {
    details.open = false;
    return;
  }

  details.dataset.animating = 'true';
  window.gsap.set(answer, { height: answer.offsetHeight, overflow: 'hidden' });
  window.gsap.to(answer, {
    height: 0,
    opacity: 0,
    y: -8,
    duration: 0.45,
    ease: 'power2.inOut',
    onComplete: function () {
      details.open = false;
      answer.style.overflow = '';
      answer.style.height = '';
      answer.style.opacity = '';
      answer.style.transform = '';
      details.dataset.animating = 'false';
    },
  });

  if (icon) {
    window.gsap.to(icon, { rotate: 0, duration: 0.45, ease: 'power2.inOut' });
  }
}

if (!customElements.get('dbr-faq')) {
  customElements.define('dbr-faq', DbrFaq);
}
